export default __webpack_public_path__ + "static/media/new-badge.67b784eb.png";